import { QueryKeys } from "@/lib/types";

export type StudentAvailableClassesPortal = "member" | "admin";

export const MEMBER_AVAILABLE_CLASSES_PAGE_SIZE = 1000;

export function defaultPageSizeForPortal(
  portal: StudentAvailableClassesPortal,
): number {
  return portal === "member" ? MEMBER_AVAILABLE_CLASSES_PAGE_SIZE : 25;
}

export function onlyAvailableOnlineForPortal(
  portal: StudentAvailableClassesPortal,
): boolean | undefined {
  return portal === "member" ? true : undefined;
}

export type StudentAvailableClassesQueryKeyParams = {
  studentId: number;
  seasonId?: number | null;
  locationId?: number | null;
  page?: number;
  pageSize?: number;
  lastSelectedId?: number;
  active?: boolean;
  portal?: StudentAvailableClassesPortal;
};

export function getStudentAvailableClassesQueryKey({
  studentId,
  seasonId = null,
  locationId = null,
  page = 1,
  pageSize = 25,
  lastSelectedId,
  active,
  portal = "admin",
}: StudentAvailableClassesQueryKeyParams) {
  return [
    QueryKeys.StudentAvailableClasses,
    studentId,
    seasonId,
    locationId,
    page,
    pageSize,
    lastSelectedId,
    active,
    portal,
  ] as const;
}
